import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

const Loader =(props)=>{
    const {classes} = props;
    return (
        <div style={{textAlign:'center'}}>
            <CircularProgress className={classes.progress} color={'primary'}/>
        </div>
    )
};

export default withStyles(styles)(Loader);